module.exports = __webpack_public_path__ + "static/media/PSLDisplayPro.e2b3d788.ttf";